import React, { useEffect, useState } from "react";
import classNames from 'classnames';

import { Row } from "components/Layout";
import NTMSelect from "components/Buttons/NTMSelect";
import ElementModal from "./ElementModal";
import style from './_modal.module.scss';


export default function ConfigurationModal({ isOpen, onClose, submitConfiguration, initialConfiguration, sensors }) {
	const [configuration, setConfiguration] = useState(initialConfiguration)

	useEffect(() => {
		setConfiguration({
			id: initialConfiguration?.id,
			description: initialConfiguration?.description || "",
			sensorIds: initialConfiguration?.sensorIds || new Array(8).fill(null),
		})
	}, [initialConfiguration])

	function changeSensor(slotIndex, sensorId) {
		let newSensorId = parseInt(sensorId)
		let newSensorIds = configuration.sensorIds
		newSensorIds[slotIndex] = newSensorId === 0 ? null : newSensorId
		setConfiguration({
			...configuration,
			sensorId: newSensorIds
		})
	}

	let className = classNames(style.modal)

	return (
		<ElementModal isOpen={isOpen} onClose={onClose} className={className}
			submit={() => submitConfiguration(configuration)}
		>
			<Row className={style.fields}>
				<input
					type={'text'}
					placeholder={'Descrizione'}
					onChange={e => {
						let newConfig = { ...configuration }
						newConfig.description = e.target.value
						setConfiguration(newConfig)
					}}
					value={configuration?.description || ""}
				/>
			</Row>
			{
				configuration?.sensorIds.map((sensorId, index) =>
					<Row className={style.fields} key={index}>
						<div>{`SLOT${index + 1}`}</div>
						<div>
							<NTMSelect
								value={sensorId || undefined}
								onChange={e => changeSensor(index, e.target.value)}
							>
								{sensors.map(s =>
									<option key={s.id} value={s.id}>{`${s.id} - ${s.name}`}</option>
								)}
							</NTMSelect>
						</div>
					</Row>
				)
			}
		</ElementModal>
	)

}
